import Vue from "vue";
import Vuex from "vuex";
import global from "./global";

Vue.use(Vuex);

const state = {
  count: 0,
  messageCount: 0,
  shenpishezhiCount: 0,
  fuwuliebiaoCount: 0,
}
const actions = {
  saveArr(context){
    context.commit('saveArr');
  },
  increment(context, counted) {
    context.commit('increment', counted);
  },
  updateMsgCount(context, counted) {
    context.commit('updateMsgCount', counted);
  },
  pendingTrial(context, counted) {
    context.commit('pendingTrial', counted);
  },
  initiate(context, counted) {
    context.commit('initiate', counted);
  }
}
const mutations = {
  saveArr(state, arrs) {
    state.idParamsList = arrs;
  },
  increment(state, counted) {
    state.count = counted;
  },
  updateMsgCount(state, counted) {
    state.messageCount = counted;
  },
  pendingTrial(state, counted) {
    state.shenpishezhiCount = counted;
  },
  initiate(state, counted) {
    state.fuwuliebiaoCount = counted;
  }
}

export default new Vuex.Store({
  modules: {
    global,
  },
  state,
  mutations,
  actions
});
